module.exports = __webpack_public_path__ + "media/images/icons/dots-b8f236f39f0562acc250b579fb85fc14.svg";